// Redirects that keep old URLs working (bookmarks, handoff deep links,
// links other screens and the backend still emit).

import { Navigate, useParams } from "react-router-dom";

import { useCustomerAgents } from "@/api/customers";
import { isBlueprint } from "@/lib/agentKind";
import { useAuth } from "@/stores/auth";

/** /cc-sessions/:sessionId → /code/sessions/:sessionId (keeps the id). */
export function RedirectCcSession() {
  const { sessionId } = useParams<{ sessionId?: string }>();
  return <Navigate to={sessionId ? `/code/sessions/${sessionId}` : "/code/sessions"} replace />;
}

export type AgentSection = "chat" | "desktop" | "files" | "mail" | "routines" | "memory";

/**
 * The per-surface pages that became agent-workspace tabs (/chat, /files,
 * /desktops, /mail, /routines, /memories, each with an optional
 * :template) → /agents/<template>/<section>; without a template, the
 * first agent's.
 */
export function LegacyAgentSurfaceRedirect({ section }: { section: AgentSection }) {
  const { template } = useParams<{ template?: string }>();
  const customerId = useAuth((s) => s.customerId);
  const agents = useCustomerAgents(!template && customerId ? customerId : null);
  if (!template && agents.isLoading) return null;
  const target = template ?? agents.data?.agents.find((a) => !isBlueprint(a))?.template;
  return <Navigate to={target ? `/agents/${target}/${section}` : "/agents"} replace />;
}
